<input nz-input (keyup)="keyupEvent($event)" [class.border-danger]="!!messageInvalid"
       (keypress)="keypressEvent($event)" [placeholder]="csPlaceHolder | translate" (blur)="inputChange()"
       (nzPopoverVisibleChange)="!$event && inputChange()"
       nz-popover [nzPopoverContent]="pickerTpl" [nzPopoverTrigger]="'click'"
       [(ngModel)]="valueInput" [ngClass]="classes">
<span *ngIf="messageInvalid && showMessageInvalid">{{ messageInvalid }}</span>
<ng-template #pickerTpl>
  <div class="slider-picker">
    <nz-slider nzRange (ngModelChange)="progressInputValue($event)" [(ngModel)]="sliderValues"
               [nzMax]="maxValue" [nzMarks]="marksValue" [nzMin]="minValue" nzTooltipVisible="never"></nz-slider>
  </div>
</ng-template>
